<script>
    import { onMount, onDestroy } from 'svelte';
    import { Server } from "../stores.js";
    import SubHeader from "../components/SubHeader.svelte";

    let news = [];
    let more = false;
    let view = {};
    let mode = 'list';

    const getNews = async page => {
        let option = {
            headers: {'Content-type': 'application/json; charset=UTF-8'},
            method: 'GET',
        }
        let hash = location.hash.slice(1) || '/news';

        return await fetch($Server + hash + ( page ? '?page=' + page : ''), option)
            .then(async res => await res.json())
            .then(response => {
                // console.log(response);
                if (response.result === 'success') { // success
                    if (response.list) {
                        news = [...response.list];
                        mode = 'list';
                        more = response.more;
                    } else if (response.view) {
                        view = response.view;
                        mode = 'view';
                    }
                } else { // failed
                    console.log('오류가 발생하였습니다.')
                }
            })
            .catch(error => {
                console.log('오류가 발생하였습니다.')
                console.warn(error);
                return false;
            });
    }

    let timeout;
    onMount(async () => await getNews());
    onDestroy(() => clearTimeout(timeout));

    let subHeader = {
      bg_pc: '/images/sub_news.png',
      bg_mo: '/images/sub_news_m.png',
      title: '커피멘토 소식',
      dsc: 'NEWS'
    }
</script>

<SubHeader { ...subHeader } />

<div class="home__news home-news">
    <!--<div class="home-news__more-outer">-->
    <!--    <a href="/" class="home-news__more" >More +</a>-->
    <!--</div>-->
    {#if mode === 'list'}
    <ul class="home-news__list">
        {#each news as item}
            <li class="home-news__item">
                <a href="{item.link}" target="_blank" class="home-news__anchor">
                <!--<a href="#/news/{item.id}" class="home-news__anchor">-->
                    <h4 class="home-news__subject heading heading_level_4">{item.title}</h4>
                    <span class="home-news__date ">{item.shown_at_from.slice(0, 10)}</span>
                    <span class="home-news__content text">{item.content}</span>
                </a>
            </li>
        {/each}
    </ul>
    {#if more }
        <!--<a href="#/news">더보기</a>-->
    {/if}
    {:else if mode === 'view'}
        <div class="home-news__header">
            <h4 class="home-news__subject heading heading_level_4">{view.title}</h4>
            <span class="home-news__date">{view.shown_at_from.slice(0, 10)}</span>
        </div>
        <div class="home-news__content text">{view.content}</div>
        <!--<a href="#/news">목록</a>-->
    {/if}
</div>

<style>
    .home-news {
        position: relative;
    }

    .home-news:after {
        opacity: 0;
    }

    .home-news__list {
        position: relative;
        width: calc(100% - 40px);
        max-width: 1240px;
        margin: 0px auto;
        /*margin: 0 auto;*/
        border-top: solid 2px var(--tertiary);
        border-bottom: solid 1px var(--tertiary);
    }

    .home-news__item {
        position: relative;
        /*display: block;*/
    }
    .home-news__item:after {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        display: block;
        content: '';
        background: var(--secondary);
        opacity: 0;
        z-index: -1;
        transition: ease-out 0.3s;
    }
    .home-news__item:hover:after {
        opacity: 0.05;
    }

    .home-news__item:before {
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        display: block;
        content: '';
        font-size: 0px;
        height: 1px;
        background: var(--tertiary);
        opacity: 0.2;
    }
    .home-news__item:last-of-type:before {
        display: none;
    }

    .home-news__anchor {
        position: relative;
        display: block;
        text-decoration: none;
        color: var(--tertiary);
        width: 100%;
        box-sizing: border-box;
        padding: 36px 200px 36px 36px;
        text-align: justify;
    }
    .home-news__anchor:hover {
        text-decoration: none;
    }

    .home-news__subject {
        display: block;
        font-size: 130%;
        color: var(--tertiary);
    }

    .home-news__content {
        display: block;
        padding-top: 24px;
        font-size: 100%;
        color: var(--tertiary);
        white-space: nowrap;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .home-news__date {
        position: absolute;
        top: 50%;
        right: 40px;
        font-size: 100%;
        color: var(--tertiary);
        transform: translate(0%, -50%);
    }

    .home-news__more-outer {
        position: relative;
        width: calc(100% - 40px);
        max-width: 1240px;
        margin: 0 auto;
        /*bottom: 100%;*/
        /*right: 0px;*/
        padding: 95px 10px 10px 10px;
        text-align: right;
    }

    .home-news__more {
        position: relative;
        display: block;
        text-decoration: none;
        padding: 12px 6px 12px 12px;
        margin: 0 0 0 0;
        color: var(--tertiary);
    }
    .home-news__more:hover {
        text-decoration: none;
    }

    @media screen and (max-width: 900px) {
        .home-news {
            padding: 80px 0;
        }

        .home-intro__pages
        .home-news {
            /*padding-left: 20px;*/
            /*padding-right: 20px;*/
        }
        .home-news__more-outer {
            padding: 50px 10px;
        }
        .home-news__more {
            font-size: 75%;
            padding: 12px;
            margin: 0;
        }
        .home-news__anchor {
            padding: 16px 8px;
        }
        .home-news__subject {
            font-size: 85%;
        }
        .home-news__content {
            padding-top: 12px;
            font-size: 75%;
            opacity: 0.9;
        }
        .home-news__date {
            font-size: 65%;
            position: relative;
            display: block;
            top: inherit;
            right: inherit;
            opacity: 0.6;
            transform: translate(0%, 0%);
        }
    }
</style>
